import type { FullSkillEffect } from '../data/full';
import type { DecorId } from '../data/types';
import { CASCADE_ICON, JONGLEUR_MARK } from './full/jongleur';
import { SPORTIF_MARK, SPRINT_ICON } from './full/sportif';
import { MOTIF_ICON, TATOUE_MARK } from './full/tatoue';
import { RAPPEL_ICON, SUPERFAN_MARK } from './full/superfan';
import { ENRACINE_MARK, HIBOU_ICON } from './full/enracine';
import { LANTERNE_ICON, VEILLEUR_MARK } from './full/veilleur';
import { CELESTE_MARK, METEORS_ICON } from './full/celeste';
import { BABACOOL_MARK, HALF_TIME_ICON } from './full/babacool';
import { CIRCADIEN_MARK, ECLIPSE_ICON } from './full/circadien';
import { DEBANDADE_ICON, POUSSIN_MARK } from './full/poussin';
import { AVATAR_MARK, DECHAINE_ICON } from './full/avatar';
import { ECHASSIER_MARK, GRAND_PAS_ICON } from './full/echassier';
import { AMBYSS, DOME, PUMPUI } from './full/stage-previews';
import { createFestivalHud } from './full/festival-hud';
import { SPORES_ICON, STICK_ICON, createSummonsHud } from './full/summons-hud';
import type { SummonLook } from '../data/types';
import type { HudPart, HudParts } from './hud-parts';
import type { EndPartOf } from './end-parts';
import { festivalEnd } from './full/festival-end';

// The demo gets `full.demo.ts` in this file's place (ADR 0015).
export const FULL_PREVIEWS: Readonly<Record<DecorId, string>> = {
  dome: DOME,
  ambyss: AMBYSS,
  pumpui: PUMPUI,
};
export const FULL_MARKS: Readonly<Record<string, string>> = {
  sportif: SPORTIF_MARK,
  tatoue: TATOUE_MARK,
  superfan: SUPERFAN_MARK,
  enracine: ENRACINE_MARK,
  veilleur: VEILLEUR_MARK,
  celeste: CELESTE_MARK,
  babacool: BABACOOL_MARK,
  poussin: POUSSIN_MARK,
  avatar: AVATAR_MARK,
  jongleur: JONGLEUR_MARK,
  circadien: CIRCADIEN_MARK,
  echassier: ECHASSIER_MARK,
};
export const FULL_SKILL_ICONS: Readonly<Record<FullSkillEffect['kind'], string>> = {
  cascade: CASCADE_ICON,
  sprint: SPRINT_ICON,
  motif: MOTIF_ICON,
  rappel: RAPPEL_ICON,
  hibou: HIBOU_ICON,
  lanterne: LANTERNE_ICON,
  meteors: METEORS_ICON,
  halfTime: HALF_TIME_ICON,
  eclipse: ECLIPSE_ICON,
  debandade: DEBANDADE_ICON,
  dechaine: DECHAINE_ICON,
  grandPas: GRAND_PAS_ICON,
};
export const FULL_NIGHTS: { readonly festival?: true } = { festival: true };
export const FULL_HUD: Readonly<Record<string, (parts: HudParts) => HudPart>> = {
  festival: createFestivalHud,
  summons: createSummonsHud,
};
export const FULL_OFFERING_ICONS: Partial<Record<SummonLook, string>> = {
  fire: STICK_ICON,
  giants: SPORES_ICON,
};
export const FULL_END: { readonly festival?: EndPartOf } = { festival: festivalEnd };
